import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

// Components
import Button from "../components/Button";
import instructionSheets from "../data/instructionSheets"
import ScoreFunction from "../components/ScoreFunction"

class VSubmission extends Component {
 
constructor(props) {
    super(props);
	this.state = {tokenTemp:""}

	this.handleChangeToken = this.handleChangeToken.bind(this);
	this.handleTokenSubmit = this.handleTokenSubmit.bind(this);	
	

}	

	// token
handleChangeToken = (event) =>{
	this.setState({
		tokenTemp: event.target.value
	})
}

//move to feedback if the score token is correct
handleTokenSubmit = () => {
const scoreToken = instructionSheets[this.props.taskUserId]["score_token"]

if (this.state.tokenTemp!=scoreToken) {alert("You inserted a wrong Score Token")}

	
}

  render() {
	const userFinalStateBoard = this.props.userSteps[this.props.lastStepIdx]["board_state"]
	const taskId = instructionSheets[this.props.taskUserId]["taskId"]
	const score = (this.props.lastStepIdx===0)?  "No Score" : ScoreFunction(userFinalStateBoard,taskId)
	
	//user output that retrieved from App. 
	//includes {instruction sheet, steps {line_number, line instruction, boardstate, quantitative score, qualitative score}}
	const userOutput = JSON.stringify({
							"taskUserId":this.props.taskUserId,
							"taskId":taskId,
							"assigId":instructionSheets[this.props.taskUserId]["assignId"],
							"steps":this.props.userSteps,
							"score":score,
							})
	const scoreToken = instructionSheets[this.props.taskUserId]["score_token"]
		
	return (
	<div>
      <InstructionContainer>
          <h2>Good job! You are almost done</h2>
          <P>
			To complete your HIT please copy the results below by clicking on the Copy 
			 button and paste it in the Amazon MTurk interface. 
			 <br/> Make sure you do it to get your HIT done.
			<br/><br/> Make sure that your HIT token is identical to this one: &nbsp; &nbsp;      
			<b>{this.props.taskUserId}</b>
			<br/>That ensures that you are copying the right results for the HIT. 
		  </P>
		   
		  {/* check. remove in production App
		  user output: {JSON.stringify({"instruction_sheet":this.props.userInstructionSheet,"steps": this.props.userSteps})} 
		  */}
		  
		</InstructionContainer> 
        
		<DataToCopy value= {userOutput} /> 
		       
		<button style = {buttonStyle}
						onClick= {() =>{navigator.clipboard.writeText(userOutput)} }>
			Copy
		</button>
		
		
		<InstructionContainer >
		<P>
			Click the Score button to view your score.
		</P>
		</InstructionContainer>	
		
		{/* ONLP lab members insert that token: 
		<b> {scoreToken} </b>
		*/}
		
		<br/> 

		<StyledButton onClick={this.handleTokenSubmit}>
			<RedirectLink to="/feedback">Score</RedirectLink>
		</StyledButton>
		
		
	</div>	
      
    );
  }
}

export default VSubmission;

function tokenFunction (taskUserId){
	const tokenArray = instructionSheets[taskUserId]["token"]
	const token=4371*Math.pow(tokenArray[0],4) + 583*Math.pow(tokenArray[1],3) +839*Math.pow(tokenArray[2],2)

	return (token)
}

const InstructionContainer = styled.div`
background: lightblue;
margin: 1em;
width: 90vw;

`;
 
const P = styled.p`
text-align: left;
font-size: large;
`;

const DataToCopy = styled.textarea`
  width: 80vw;
  height: 40vh;
  align-self: center;
  margin-bottom: 2rem;
  color: darkblue;
  font-size: 12px;
  padding: 8px;
`;

const buttonStyle ={background:"red", 
					width:"8vw", 
					height:"40px", 
					float:"right", 
					marginTop:"20vh", 
					color: "white", 
					borderRadius:"8px"}

const StyledButton = styled(Button)`
  width: 10%;
  margin-left: 45%;
  background: ;
`;

const RedirectLink = styled(Link)`
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0);
  padding: 20px 10px;
  border-radius: 4px;
  text-decoration: none;
  color: inherit;
  transition: all 300ms;
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;